import tippy from 'tippy.js'
import {
  awaitSelector,
  watchAwaitSelector,
  removeClass,
  updateSelectedOption,
  equalHeights,
  throttle,
  getNumPerRow,
  outerWidth
} from './functions'

HTMLDocument.prototype.ready = function () {
  // Document load/ready promise, calls 'ready' method when completed
  return new Promise(function (resolve, reject) {
    if (document.readyState === 'complete') {
      resolve(document)
    } else {
      document.addEventListener('DOMContentLoaded', function () {
        resolve(document)
      })
    }
  })
}

document.ready().then(function () {
  // const selectMenus = document.querySelectorAll('.ProductForm__VariantSelector')
  // for (const menu of selectMenus) {
  //   const options = menu.querySelectorAll('option')
  //   const content = document.createElement('div')
  //   content.classList.add('Tooltip__Content')
  //   console.log(menu)
  //   for (const option of options) {
  //     const newVariant = document.createElement('button')
  //     // newVariant.classList.add('Tooltip__Option');
  //     newVariant.setAttribute('data-variant', option.dataset.variant)
  //     newVariant.setAttribute('data-variant-name', option.dataset.variantName)
  //     newVariant.setAttribute('data-variant-color', option.dataset.variantColor)
  //     newVariant.setAttribute('data-sku', option.dataset.sku)
  //     newVariant.textContent = option.dataset.variantName
  //     content.insertAdjacentElement('beforeend', newVariant)
  //   }
  //   document.body.insertAdjacentElement('beforeend', content)
  //   console.log(content)
  //   const tooltip = tippy(menu, {
  //     interactive: true,
  //     interactiveBorder: 10,
  //     placement: 'left',
  //     trigger: 'click',
  //     allowHTML: true,
  //     content,
  //     onCreate(instance) {
  //       console.log('created...')
  //       console.log(instance)
  //     }
  //   })
  //   console.log(tooltip)
  //   menu.addEventListener('click', function (event) {
  //     console.log(event)
  //     event.preventDefault()
  //     tooltip.show()
  //   })
  // }
})
